import styled from 'styled-components';

export const UserSettingsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-left: 24px;
  height: 100%;

  h1 {
    font: 700 1.5rem/1.8rem 'Segoe UI', sans-serif;
  }

  .ms-DetailsRow {
    &:hover .mgt-person {
      background: ${(props) => props.theme.neutralLighter};
    }
    .mgt-person {
      background: ${(props) => props.theme.white};
    }
  }

  #internaluserscontainer {
    height: 100%;
  }
`;

export const ManageUserPanelFooter = styled.div`
  display: flex;
  gap: 0.5rem;
`;
